import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management" }, { title: "menu_sidebar_management_features" }];

const Features = Loadable({
  loader: () => import("container/management/features"),
  loading() {
    return <Loader />;
  }
});

export const featureRoutes: IRoute[] = [
  {
    path: "/management/features",
    element: <Features />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
